import { useEffect, useState } from 'react';

import { getConnectedSensorNames } from 'common/services/linked-accounts.service';
import { LOADING_STATUS } from 'common/constants/constants';

export const useGetConnectedSensors = ({ token, sensorTypeId }) => {
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(LOADING_STATUS.INIT);

  useEffect(() => {
    if (!token) return;

    const fetchData = async () => {
      try {
        const connectedSensors = await getConnectedSensorNames(
          token,
          sensorTypeId
        );
        setData(connectedSensors.data.map(s => s.toLowerCase()));
      } catch (e) {
        setData([]);
        setError(e);
      }
      setStatus(LOADING_STATUS.COMPLETED);
    };

    fetchData();
  }, [token, sensorTypeId]);

  return { error, data, status };
};
